import React from 'react'
import styled from '@emotion/styled'
import { Progress } from 'antd'

import UploadResumeWrap from './Wrap.mobile'
import { useUploadResumeContext } from './context'

import { ReactComponent as FileIcon } from '../../images/svg/uploadingFile.svg'

const UploadMain = (props: { lang: any }) => {
  const { lang = {} } = props
  const profile = lang.profile || {}
  const { progress } = useUploadResumeContext()

  const handleBack = () => {
    if (typeof window !== 'undefined') {
      window.history.back()
    }
  }

  return (
    <UploadResumeWrap
      {...props}
      footer={
        <FooterWrap>
          <BackButton onClick={handleBack}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M5.25 13.5L1.5 9L5.25 4.5'
                stroke='#121212'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>{' '}
            <p className='countdownText'>{profile.back}</p>
          </BackButton>
        </FooterWrap>
      }
    >
      <ContentWrap>
        <div className='modal-content'>
          <div className='progress-file-info'>
            <FileIcon className='progress-file-icon' />
            <p className='progress-file-message'>{profile?.uploadResumeModal?.uploadingTip}</p>
            <Progress
              className='progress-file-progress'
              size={'small'}
              type='line'
              strokeColor={'#3CEAF6'}
              percent={progress}
              showInfo={false}
            />
          </div>
        </div>
      </ContentWrap>
    </UploadResumeWrap>
  )
}

const FooterWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  background: #fff;
  z-index: 12;

  .footer-btns {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`

const BackButton = styled.div`
  display: inline-flex;
  height: 44px;
  padding: 10px 10px 10px 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  p.countdownText {
    color: #111212;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
`

const ContentWrap = styled.div`
  padding-top: 24px;
  padding-bottom: 0;

  .modal-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 16px;
    border: 3px dashed #ebeef0;
    background: #fdfdfd;
  }

  .progress-file-info {
    display: flex;
    padding: 52px 24px 52px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
  }

  .progress-file-progress {
    width: 100%;
    max-width: 80%;
    margin: 10px 0 0;
  }

  .progress-file-message {
    color: #111212;
    font-family: SSFProDisplay !important;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    width: 100%;
    margin-top: 24px;
  }
`

export default UploadMain
